import { z } from "zod";

import { CampaignWithIdSchema } from "../../../dtos/deprecated/campaigns";
import { castToBool } from "../../../utils";

export const GetCampaignsResponseBodySchema = z.object({
  campaigns: CampaignWithIdSchema.array(),
});
export type GetCampaignsResponseBodyType = z.infer<
  typeof GetCampaignsResponseBodySchema
>;

export const GetCampaignsRequestQueryParamSchema = z.object({
  includeDiscount: castToBool.optional(),
});

export type GetCampaignsRequestQueryParamType = z.infer<
  typeof GetCampaignsRequestQueryParamSchema
>;
